<template lang="pug">
  #certificate
    section.banner.position-relative
        div.picture
            img.img-fluid.big(src="img/banner/banner_certificate.jpg" alt="banner-certificate")
            img.img-fluid.small(src="img/banner/banner_certificate_mobile.jpg" alt="banner-certificate")
        div.mask_banner
        div.breadcrumb_block
            b-container
                b-breadcrumb(:items="breadcrumb_items")
        div.banner_h1
            h1 品質認證
    b-container.py-sm-3.slogan
        p.text-center.font-weight-bolder.pt-5 南亞塑膠除了致力開發優質的產品之外，在品質管理、安全管理及產品認證等，皆不遺餘力投入心力。
    section
        b-container.container_small
            //- .cert_1.position-relative.clearfix.py-5
            //-     .cert_block.absolute_left.animate_left.text-center
            //-         b-img(src="img/certification/bg_certification_1.jpg" fluid-grow)
            //-     .cert_block.cert_block_box.float_rifht.mt-0.mt-lg-5.animate_right
            //-         div.p-5
            //-             h2.color_first.font-weight-bold.py-3 工廠認證
            //-             p.py-3 品質管理部份通過ISO9001:2015，南亞提供的不止穩定的品質，更要達到最高標準；環境管理通過ISO14001:2015為新創的環境保護制度，對環境保護執行的企業責 任；職業安全管理通過OHSAS18001:2007及台灣安全衛生管理系統(TOSHMS)，優質的企業除品質及環境保護外，對生產之安全更加重視。
            //-             b-row.justify-content-center
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_ISO9001.jpg" fluid-grow)
            //-                     p.text-certificate ISO 9001
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_ISO14001.jpg" fluid-grow)
            //-                     p.text-certificate ISO 14001
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_OHSAS18001.jpg" fluid-grow)
            //-                     p.text-certificate OHSAS 18001
            .cert_2.position-relative.clearfix.py-5
                .cert_block.cert_block_box.float_left.mt-0.mt-lg-5.wow.animate_left
                    div.p-5
                        h2.color_first.font-weight-bold.py-3 食品安全認證
                        p.py-3 南亞硬質膠布主要用於包裝，且通常直接接觸產品，若接觸一般文具、工具、水果包裝沒有食安問題，但直接與食品及藥品的接觸難免會讓消費者不安心，因此南亞更超前佈署食品、藥品認證，為台灣唯一通過FDA美國食藥署認證之PVC包裝材料。
                        b-row
                            b-col(cols="4")
                                b-img(src="img/certification/certification_CDER.jpg" fluid-grow)
                                p.text-certificate FDA
                .cert_block.absolute_right.wow.animate_right.text-center
                    b-img(src="img/certification/bg_certification_2.jpg" fluid-grow)
            //- .cert_3.position-relative.clearfix.py-5
            //-     .cert_block.absolute_left.wow.animate_left.text-center
            //-         b-img(src="img/certification/bg_certification_3.jpg" fluid-grow)
            //-     .cert_block.cert_block_box.float_rifht.mt-0.mt-lg-5.wow.animate_right
            //-         div.p-5
            //-             h2.color_first.font-weight-bold.py-3 國家級實驗室
            //-             p.py-3 一般的供應商檢驗，會因為設備、人員等因素造成誤差，南亞新港廠於2020年通過TAF(財團法人全國認證基金會)實驗室認證，檢驗數據秉持TAF的理念-公正、獨立、透明，給客戶最安心的品質與保障。
            //-             b-row.justify-content-end
            //-                 b-col(cols="4")
            //-                     b-img(src="img/certification/certification_TAF.jpg" fluid-grow)
            //-                     p.text-certificate TAF
</template>

<script>
export default {
    metaInfo: {
        title: '品質認證-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: '南亞塑膠除了致力開發優質的產品之外，在品質管理、安全管理及產品認證等，皆不遺餘力投入心力。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、品質認證、品質管理、安全管理、產品認證。' },
            { name: 'og:title', content: '品質認證-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: '南亞塑膠除了致力開發優質的產品之外，在品質管理、安全管理及產品認證等，皆不遺餘力投入心力。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: 'Home',
                    to: { name: 'App' }
                },
                {
                    text: '品質認證',
                    active: true
                }
            ]
        }
    }
}
</script>

<style lang="sass">
.breadcrumb 
    background-color: transparent

.cert_block
    width: 60%

.float_left
    float: left
    position: relative
    z-index: 3

.float_rifht
    float: right
    position: relative
    z-index: 3

.absolute_left
    position: absolute
    left: 0
.absolute_right
    position: absolute
    right: 0

.cert_block_box
    box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.5)
    background-color: #fafafa
    img
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5)
    p
        color: rgba(0, 0, 0, 0.5)
        line-height: 1.94
        letter-spacing: 0.96px
    p.text-certificate
        font-size: 14px
        color: #000000
        text-align: center

.container_small
    overflow: hidden
@media all and (max-width: 991px) 
    .cert_block
        width: 100%
    .absolute_left, .absolute_right
        position: relative
    .float_left, .float_rifht
        float: none
    .cert_2
        display: flex
        flex-wrap: wrap
        .cert_block
            flex: 0 0 100%
            max-width: 100%
        .cert_block_box
            order: 1
@media all and (max-width: 768px) 
    .container_small
        max-width: 100% !important
        padding-left: 0
        padding-right: 3px
        overflow: hidden
        .cert_block
            img
                width: 90% !important


</style>